import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";
import Formatter from "../../Localization/Formatter";

class AgencyFeeUpdateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    this.component.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_UPDATE_CLEAR
    });

    let vatPercentage = "";

    if (this.component.agencyFee && this.component.agencyFee.fixedFee) {
      const vatPercentageNumber = Math.round(this.component.agencyFee.vat / (this.component.agencyFee.fixedFee - this.component.agencyFee.vat) * 100);

      if (!isNaN(vatPercentageNumber)) {
        vatPercentage = Formatter.simpleFormatNumber(vatPercentageNumber, false, false);
      }
    }

    this.component.setState({
      currency: this.component.agencyFee && this.component.agencyFee.currency.getCurrencyId(),
      fixedFee: this.component.agencyFee && ((!this.component.agencyFee.fixedFee && this.component.agencyFee.fixedFee !== 0) ? "" : Formatter.simpleFormatNumber(this.component.agencyFee.fixedFee)),
      percentageFee: Formatter.simpleFormatNumber(this.component.agencyFee.percentageFee, false),
      fixedPlusPercentageMode: this.component.agencyFee && this.component.agencyFee.fixedPlusPercentageMode,
      vat: this.component.agencyFee && (!this.component.agencyFee.vat ? "" : Formatter.simpleFormatNumber(this.component.agencyFee.vat)),
      vatPercentage: vatPercentage,
      firstDate: this.component.agencyFee && (!this.component.agencyFee.firstDate ? null : this.component.agencyFee.firstDate),
      lastDate: this.component.agencyFee && (!this.component.agencyFee.lastDate ? null : this.component.agencyFee.lastDate),
      dateChoice: !!this.component.agencyFee && this.component.agencyFee.firstDate ? "firstDate" : "contractDate",
      firstDateError: "",
      chargeTypeIds: this.component.agencyFee?.chargeTypeIds || [],
      isEndAgencyFeeDialogOpen: false,
      repeatPeriod: this.component?.agencyFee?.repeatPeriod,
      assignmentServiceStatus: this.component?.agencyFee?.assignmentServiceStatus,
      date: this.component?.agencyFee?.date,
    });
  }
}

export default new AgencyFeeUpdateWillMount();
